import Button from '@/components/Button/Button';

type DiscardChangesPopupProps = {
  onCancel: () => void;
  onConfirm: () => void;
};

const DiscardChangesPopup = ({ onCancel, onConfirm }: DiscardChangesPopupProps) => {
  return (
    <div>
      <p className="text-sm text-ds-gray-500">
        You’ve made changes to this table. If you proceed now, your updates won’t be saved. Are you
        sure you want to proceed?
      </p>
      <div className="mt-4 flex justify-end gap-2">
        <Button color="outlined" size="lg" onClick={onCancel}>
          Continue Editing
        </Button>
        <Button size="sm" color="error" type="button" onClick={onConfirm}>
          Proceed
        </Button>
      </div>
    </div>
  );
};

export default DiscardChangesPopup;
